var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.12848 9.16667L15.5769 18.979M15.5769 18.979L6.12848 30.8333M15.5769 18.979L17.7257 21.2105C19.0063 22.4058 20.9938 22.4058 22.2745 21.2105L24.5333 18.979M34.1667 9.46182L24.5333 18.979M24.5333 18.979L34.1667 30.5382M6.12848 30.8333C6.71608 31.352 7.48797 31.6667 8.33333 31.6667H31.6667C32.6622 31.6667 33.5558 31.2302 34.1667 30.5382M6.12848 30.8333C5.43647 30.2225 5 29.3288 5 28.3333V11.6667C5 9.82572 6.49238 8.33333 8.33333 8.33333H31.6667C33.5077 8.33333 35 9.82572 35 11.6667V28.3333C35 29.1787 34.6853 29.9505 34.1667 30.5382",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7840f491b0cdf46f3f695b0c54040001.svg";
export { ForwardRef as ReactComponent };